import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/mindaffect.webp';
import screenshot_target from '../../../images/letterfunnel/jennifergoodall.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jennifer Goodall"
      firstname="Jennifer"
      companyname="MindAffect"
      competition="MAICO en Interacoustics"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jennifergoodall.js